/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/coming-soon.js":
/*!*********************************************!*\
  !*** ./src/scripts/sections/coming-soon.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_coming_soon_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/coming-soon.scss */ \"./src/styles/sections/coming-soon.scss\");\n\nconst SELECTORS = {\n  popupTrigger: '.js-coming-soon-popup-trigger',\n  popup: '.js-coming-soon-popup',\n  popupContainer: '.js-coming-soon-popup-container',\n  popupClose: '.js-coming-soon-popup-close'\n};\nconst initCommingSoon = () => {\n  const $popup = document.querySelector(SELECTORS.popup);\n  if (!$popup) return;\n  const $trigger = document.querySelector(SELECTORS.popupTrigger);\n  if (!$trigger) return;\n  const $body = document.body;\n  $trigger.addEventListener('click', () => {\n    $body.classList.add('popup_open');\n  });\n  $popup.addEventListener('click', ({\n    target\n  }) => {\n    const $close = target.closest(SELECTORS.popupClose);\n    const isOverlay = target === $popup;\n    if ($close || isOverlay) {\n      $body.classList.remove('popup_open');\n    }\n  });\n};\ndocument.addEventListener('DOMContentLoaded', () => {\n  initCommingSoon();\n});\n\n//# sourceURL=webpack://project_name/./src/scripts/sections/coming-soon.js?\n}");

/***/ }),

/***/ "./src/styles/sections/coming-soon.scss":
/*!**********************************************!*\
  !*** ./src/styles/sections/coming-soon.scss ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://project_name/./src/styles/sections/coming-soon.scss?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/coming-soon.js");
/******/ 	
/******/ })()
;